import { useEffect, useState } from "react";
import { resolver } from "../../../API/middlewares/resolveRequests";
import {
  getAllActivityStatus,
  getEditActivityProcedureForm,
  updateActivityProcedureStatus,
} from "../../../API/store/actions/projects/projects";
import Bullets from "../../sharedComponents/bullets/bullets";

const EditActivityProcStatus = ({
  userToken,
  procId,
  procAdded,
  setProcAdded,
}) => {
  const [status, setStatus] = useState(null);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [proc, setProc] = useState(null);

  useEffect(() => {
    setStatus(null);
    resolver(getAllActivityStatus, setStatus, userToken);
    resolver(getEditActivityProcedureForm, setProc, procId, userToken);
  }, []);

  useEffect(() => {
    if (currentStatus) {
      updateActivityProcedureStatus(procId, currentStatus, userToken);
    }
  }, [currentStatus]);

  //   useEffect(() => {
  //     if (currentStatus) resolver(procData, setProc, procId);
  //   }, [currentStatus]);

  if (status && proc) {
    return (
      <div className="d-flex flex-lg-row flex-column justify-content-between mx-3 ">
        <div style={{ fontSize: 18 }}>{proc?.data?.description}</div>
        <div className="d-flex align-items-center justify-content-center col-lg-3 col-12 mt-lg-0 mt-3">
          {status?.data?.projectStatusLkp.map((item, index) => {
            return (
              <div className=" d-flex flex-column justify-content-center align-items-center mx-2">
                <Bullets
                  key={index}
                  containerStyle={{ width: 21 }}
                  memberId={proc?.data?.id}
                  id={item?.id}
                  borderColor={"#1a73e8"}
                  bulletColor={item?.color}
                  tooltipTitle={item?.name}
                  setActive={setCurrentStatus}
                  procAdded={procAdded}
                  setProcAdded={setProcAdded}
                  active={currentStatus ?? proc?.data?.projectStatusId}
                />

                <div className=" text-center">{item.name} </div>
              </div>
            );
            //   procStatus ??
          })}
        </div>
      </div>
    );
  }
  return <>Loading</>;
};
export default EditActivityProcStatus;
